import * as queries from './queries';
import app from '../../app';

async function getPatientSummaryData(patientId, commit, dispatch) {
    if (!patientId) {
        commit('set', null);
        return;
    }

    try {
        patientId = parseInt(patientId);
        const {data, errors} = await app.apolloClient.query({
            query: queries.getPatientSummary,
            variables: {patientId},
        });

        if (data && !errors) {
            commit('set', data.patientSummary);
        } else if (errors.length) {
            errors.forEach((error) => {
                dispatch('error/submit', error, {root: true});
            });
        }
    } catch (error) {
        dispatch('error/submit', error, {root: true});
    }
}

export async function get({dispatch, commit, getters}, patientId) {
    if (patientId === getters.id) {
        return;
    }

    await getPatientSummaryData(patientId, commit, dispatch);
    await getEventData({commit, dispatch}, patientId);
}

export async function update({dispatch, commit, getters}) {
    await getPatientSummaryData(getters.id, commit, dispatch);
}

export async function updateTargetWeight({ commit }, targetWeight) {
    commit('updateTargetWeight', targetWeight);
}

export function reset({commit}) {
    commit('reset');
}

export async function dropOut({dispatch}, patientId) {
    try {
        patientId = parseInt(patientId);
        const {data, errors} = await app.apolloClient.query({
            query: queries.dropOut,
            variables: {patientId},
        });

        if (data && !errors) {
            return true;
        } else if (errors.length) {
            errors.forEach((error) => {
                dispatch('error/submit', error, {root: true});
            });

            return false;
        }

        return false;
    } catch (error) {
        dispatch('error/submit', error, {root: true});
        return false;
    }
}

export async function logOut({dispatch}, patientId) {
    try {
        patientId = parseInt(patientId);
        const {data, errors} = await app.apolloClient.query({
            query: queries.logOut,
            variables: {patientId},
        });

        if (data && !errors) {
            return true;
        } else if (errors.length) {
            errors.forEach((error) => {
                dispatch('error/submit', error, {root: true});
            });

            return false;
        }

        return false;
    } catch (error) {
        dispatch('error/submit', error, {root: true});
        return false;
    }
}

export async function resetPassword({dispatch, commit, rootGetters}) {
    const patientId = parseInt(rootGetters['patientSummary/id']);

    try {
        const {data, errors} = await app.apolloClient.mutate({
            mutation: queries.resetPassword,
            variables: {patientId},
        });

        if (data && !errors) {
            return data;
        } else if (errors.length) {
            errors.forEach((error) => {
                dispatch('error/submit', error, {root: true});
            });

            return null;
        }
    } catch (error) {
        dispatch('error/submit', error, {root: true});
    }
}

export function requireReset({commit}) {
    commit('requireReset');
}

export async function set({dispatch, commit, getters}, patientId) {
    await getPatientSummaryData(patientId, commit, dispatch);
}

export function toggleUnsavedChanges({ commit }, unsavedChanges) {
    commit('toggleUnsavedChanges', unsavedChanges);
}

export function toggleMultipleUnsavedChanges({ commit }, data) {
    commit('toggleMultipleUnsavedChanges', data);
}

export function removeUnsaved({ commit }) {
    commit('removeUnsaved');
}

export async function getEventData({commit, dispatch}, patientId) {
    try {
        patientId = parseInt(patientId);
      const { data, errors } = await app.apolloMobileClient.query({
        query: queries.getEventData,
        variables: { patientId },
      });

      if (data && !errors) {
        const hadEvent = data.myDSSInfo.hadSecondVascularEventOnStatins || false
        commit('setEventData', hadEvent);

      } else if (errors.length) {
        errors.forEach((error) => {
          dispatch('error/submit', error, { root: true });
        });
      }
    } catch (error) {
      dispatch('error/submit', error, { root: true });
    }
  }

  export async function toggleBlockAccount({commit, dispatch}, {patientId, block}) {
    try {
        const {data, errors} = await app.apolloClient.query({
            query: queries.blockAccount,
            variables: { patientId : parseInt(patientId), block },
        });

        if (data && !errors) {
            commit('toggleBlockedAccount', block)
            return true;
        } else if (errors.length) {
            errors.forEach((error) => {
                dispatch('error/submit', error, {root: true});
            });

            return false;
        }

        return false;
    } catch (error) {
        dispatch('error/submit', error, {root: true});
        return false;
    }
}